import { z } from "zod";

export const SlackDeliveryMethod = z.enum(["webhook", "channel"]);
export const SlackNotifyEvent = z.enum([
  "batch_invoked",
  "batch_started",
  "batch_completed",
  "batch_cancelled",
  "batch_timeout",
  "case_passed",
  "case_warning",
  "case_error",
  "case_anomalies",
  "case_skipped",
]);
export const defaultSlackNotifyEvents: z.infer<typeof SlackNotifyEvent>[] = [
  "batch_invoked",
  "batch_started",
  "batch_completed",
  "batch_cancelled",
  "batch_timeout",
  "case_warning",
  "case_error",
  "case_anomalies",
];
export const SlackConfig = z.object({
  id: z.number().int(),
  client_id: z.number().int(),
  project_id: z.number().int().nullish(),
  enabled: z.boolean(),
  use_client_settings: z.boolean(),
  delivery_method: SlackDeliveryMethod,
  webhook_url: z.string(),
  channel: z.string(),
  notify_events: SlackNotifyEvent.array(),
  has_bot_token: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export const SlackConfigCreate = z.object({
  project_id: z.number().int().nullish(),
  enabled: z.boolean().optional(),
  use_client_settings: z.boolean().optional(),
  delivery_method: SlackDeliveryMethod.optional(),
  webhook_url: z.string().optional(),
  channel: z.string().optional(),
  bot_token: z.string().optional(),
  notify_events: SlackNotifyEvent.array().optional(),
});
export const SlackConfigUpdate = z.object({
  enabled: z.boolean().nullish(),
  use_client_settings: z.boolean().nullish(),
  delivery_method: SlackDeliveryMethod.nullish(),
  webhook_url: z.string().nullish(),
  channel: z.string().nullish(),
  bot_token: z.string().nullish(),
  notify_events: SlackNotifyEvent.array().nullish(),
});
export type SlackConfigValue = z.infer<typeof SlackConfig>;
export type SlackNotifyEventValue = z.infer<typeof SlackNotifyEvent>;
